import { isNotBlank } from 'components/Common/Utils/StringUtils';
import * as Constants from 'constants/Constants';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './materialStyles.scss';
import * as serviceWorker from './serviceWorker';

const redirectToAutomation = new URLSearchParams(window.location.search).get('identity_provider');

let renderDOM = false;
if (isNotBlank(redirectToAutomation) && redirectToAutomation === Constants.TRIMBLE_AUTOMATION) {
    sessionStorage.setItem('identity_provider', redirectToAutomation);
    renderDOM = true;
} else {
    renderDOM = true;
}

if (renderDOM) {
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(<App />, document.getElementById('root'));
}
serviceWorker.unregister();
